import DatabaseSqlite from "better-sqlite3";
import Database from "./Database";
import DocumentResource from "../Entity/DocumentResource";

export default class DocumentResourceRepository {
    private database: DatabaseSqlite.Database;

    public constructor(
        database: Database
    ) {
        this.database = database.getDatabase();
    }

    public getByDocumentReference(documentReference: number): DocumentResource | null {
        try {
            const select = this.database.prepare("SELECT * FROM docs_resources WHERE doc_ref = ?");
            const row: any = select.get(documentReference);
            if (row) {
                return this.createDocumentResourceFromRow(row);
            }
        } catch (error) {
            console.error("Error when attempting to retrieve the document resource by document reference:", error);
        }

        return null;
    }

    public getAllByResourceId(resourceId: number): DocumentResource[] {
        try {
            const select = this.database.prepare("SELECT * FROM docs_resources WHERE resource_id = ?");
            const rows: any[] = select.all(resourceId);
            return rows.map(row => this.createDocumentResourceFromRow(row));
        } catch (error) {
            console.error("Error when attempting to retrieve the document resource by resource ID:", error);
        }

        return [];
    }

    public getById(id: string): DocumentResource | null {
        try {
            const select = this.database.prepare("SELECT * FROM docs_resources WHERE id = ?");
            const row: any = select.get(id);
            if (row) {
                return this.createDocumentResourceFromRow(row);
            }
        } catch (error) {
            console.error("Error when attempting to retrieve the document resource by ID:", error);
        }

        return null;
    }

    private createDocumentResourceFromRow(row: any): DocumentResource {
        return new DocumentResource(row.id, row.resource_id, row.doc_ref);
    }

    public save(documentResource: DocumentResource): void {
        this.getById(documentResource.getId()) ? this.update(documentResource) : this.insert(documentResource);
    }

    private insert(documentResource: DocumentResource): void {
        try {
            const insert = this.database.prepare("INSERT OR IGNORE INTO docs_resources (id, resource_id, doc_ref) VALUES (?,?,?)");
            insert.run(documentResource.getId(), documentResource.getResourceId(), documentResource.getDocumentReference());
        } catch (error) {
            console.error("Error when attempting to insert the document resource:", error);
        }
    }

    private update(documentResource: DocumentResource): void {
        try {
            const update = this.database.prepare("UPDATE docs_resources SET resource_id = ?, doc_ref = ? WHERE id = ?");
            update.run(documentResource.getResourceId(), documentResource.getDocumentReference(), documentResource.getId());
        } catch (error) {
            console.error("Error when attempting to update the document resource:", error);
        }
    }

    public remove(id: string): void {
        try {
            const remove = this.database.prepare("DELETE FROM docs_resources WHERE id = ?");
            remove.run(id);
        } catch (error) {
            console.error("Error when attempting to delete the document resource:", error);
        }
    }
}